import getWindow from './getWindow.js';

function getWindowScroll(node) {
  var win = getWindow(node);
  var scrollLeft = win.pageXOffset;
  var scrollTop = win.pageYOffset;
  return {
    scrollLeft: scrollLeft,
    scrollTop: scrollTop
  };
}

export { getWindowScroll as default };
//# sourceMappingURL=getWindowScroll.js.map
